import { useUser } from '@utmb/contexts/AuthContext';
import { Icon } from '@utmb/design-system/icons/Icon';
import { Font } from '@utmb/design-system/text/font';
import { IconsEnum } from '@utmb/types/icons';
import { ReactElement } from 'react';
import styles from './my-utmb-label.module.scss';

export const MyUtmbLabel = ({ forcePlus }: { forcePlus?: boolean }): ReactElement => {
    const { me } = useUser();

    const loyalty = me?.loyalty ?? false;

    return (
        <div className={styles.container}>
            <Font.FuturaMedium as="span">MY</Font.FuturaMedium>
            <Font.FuturaBold as="span">UTMB</Font.FuturaBold>
            {(loyalty !== false || forcePlus) && forcePlus !== false ? <Icon variant={IconsEnum.PLUS_LOYALTY} clss={styles.plus} /> : ''}
        </div>
    );
};
